var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.card
    ? _c("div", [
        _c("div", { staticClass: "payment card" }, [
          _c(
            "div",
            {
              staticClass: "content",
              class: [{ active: _vm.cardLoaded }, _vm.cardBrand]
            },
            [
              _c("div", { staticClass: "brand-logo" }, [
                _c("img", {
                  staticClass: "ui image",
                  attrs: { src: _vm.cardBrandImage }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cardnumber" }, [
                _c("span", [_vm._v("••••")]),
                _vm._v(" "),
                _c("span", [_vm._v("••••")]),
                _vm._v(" "),
                _c("span", [_vm._v("••••")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.last4Digits))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cardinfo" }, [
                _c("div", { staticClass: "cardholder" }, [
                  _c("div", { staticClass: "pay-label" }, [
                    _vm._v(_vm._s(_vm.$t("components.card.card_holder")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-header" }, [
                    _vm._v(_vm._s(_vm.cardHolderName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "expirydate" }, [
                  _c("div", { staticClass: "pay-label" }, [
                    _vm._v(_vm._s(_vm.$t("components.card.expires")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-header" }, [
                    _vm._v(_vm._s(_vm.cardExpires))
                  ])
                ])
              ])
            ]
          )
        ])
      ])
    : !_vm.card && _vm.cardType.length > 0 && _vm.cardType === "mobile_pay"
    ? _c("div", { staticClass: "payment card" }, [
        _c("div", { staticClass: "content MOBILEPAY active" }, [
          _c("div", { staticClass: "center-block" }, [
            _c("img", {
              staticClass: "ui image",
              attrs: { src: _vm.mobilePayImage, alt: "Mobile Pay" }
            })
          ])
        ])
      ])
    : !_vm.card && _vm.cardType.length > 0 && _vm.cardType === "vipps"
    ? _c("div", { staticClass: "payment card" }, [
        _c("div", { staticClass: "content VIPPS active" }, [
          _c("div", { staticClass: "center-block" }, [
            _c("img", {
              staticClass: "ui image",
              attrs: { src: _vm.vippsImage, alt: "Vipps" }
            })
          ])
        ])
      ])
    : !_vm.card && _vm.cardType.length === 0
    ? _c("div", { staticClass: "payment card" }, [
        _c("div", { staticClass: "content active" }, [
          _c("div", { staticClass: "center-block no-card" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("components.card.no_card")) + "\n    "
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3e585ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3e585ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/Card.vue
// module id = sbSF
// module chunks = 1